import type { Me } from '@/features/auth/sessao';
import { permissoesDe } from './acesso';
import type { CodigoDaTela } from './telas';

/** A tela pedida não está liberada para quem está logado (spec 003, CA-02). */
export class ErroSemAcessoATela extends Error {
  constructor() {
    super('Sem acesso a esta tela');
    this.name = 'ErroSemAcessoATela';
  }
}

export function eErroSemAcessoATela(erro: unknown): erro is ErroSemAcessoATela {
  return erro instanceof ErroSemAcessoATela;
}

interface ContextoComMe {
  context: { me: Me };
}

/**
 * Opções comuns das rotas de tela: marca a tela (menu ativo e título da aba) e barra quem não
 * pode vê-la, mesmo digitando a URL (CA-02). O erro aparece dentro do layout, no lugar da tela.
 *
 *   createFileRoute('/_autenticado/alunos/')({ ...rotaDeTela('alunos.lista'), component })
 */
export function rotaDeTela(tela: CodigoDaTela) {
  return {
    staticData: { tela },
    beforeLoad: ({ context }: ContextoComMe) => {
      if (!permissoesDe(context.me).podeVerTela(tela)) throw new ErroSemAcessoATela();
    },
  };
}

/** Área da plataforma: só o super-admin (CA-08; spec 014). */
export function rotaDaPlataforma(titulo: string) {
  return {
    staticData: { titulo, plataforma: true },
    beforeLoad: ({ context }: ContextoComMe) => {
      if (!context.me.superAdmin) throw new ErroSemAcessoATela();
    },
  };
}
